import { ROUTE } from 'constant';
import React from 'react';
import { withRouter } from 'react-router-dom';
import Shared from 'screens/shared';
import { createLink, extractDatacenterId } from 'utils';

export default withRouter(({ groupServers = [], history }) => (
  <Shared.widgets.Section
    items={groupServers}
    sectionTitle="Servers"
    setItemTitle={(e) => e.name}
    itemOnClick={(e) => {
      const dcId = extractDatacenterId(e?.datacenterServer?.href);
      console.log(e);
      history.push(createLink(ROUTE.DASHBOARD.SERVER, { dcId, id: e?.datacenterServer?.id }));
    }}
    itemIcon="server"
    setItemDetails={() => 'Server'}
  />
));
